import React from 'react';
import LoadingSpinner from '../app_components/LoadingSpinner';

class BtnPrimary extends React.Component {
  constructor(props) {
    super(props);
    this.className = this.className.bind(this);
  }

  className() {
    if (this.props.alert) {
      return 'lex-btn lex-btn--destructive';
    }
    return 'lex-btn lex-btn--primary';
  }

  render() {
    return (
      <button
        style={{
          width: (this.props.fullWidth === true ? '100%' : 'auto'),
          marginTop: 24,
        }}
        className={this.className()}
        onClick={() => this.props.onClick()}
        disabled={this.props.loading === true}
        aria-busy={this.props.loading === true}
      >
        {this.props.loading
          ? <LoadingSpinner size={22} variant="white" />
          : this.props.buttonText}
      </button>
    );
  }
}

export default BtnPrimary;
